import { IsiDtoPlRacResult } from "./Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPlRac";
import { PARC095 } from "./Business/PARC095";
import { IIsiUIFlowResult, IsiDtoGLOB002OpenArgs } from "./Dtos/Isilog.IsiComponent.IsiDataTransferObject.IsiPopins";
import { IsiShortcut } from "./Isilog.enums";
import { GLOB002 } from "./Isilog.popins";
import { IsiPlDesign } from "./Isilog/PresentationLogic/IsiPlDesign";
import { IsiPlDiagHeader } from "./Isilog/PresentationLogic/IsiPlDiagHeader";
import { IsiPlRacBandeau } from "./Isilog/PresentationLogic/IsiPlRacBandeau";
import { IsiPlRac } from "./Isilog/PresentationLogic/IsiPlRacc";
import { getUrlVar } from "./IsiWebGUI/core.ts";



export function isiAbout() {
    GLOB002().open(IsiDtoGLOB002OpenArgs.fromJS({ base: "" }));

    return true;
}
window.isiAbout = isiAbout;


/* --CREATION -----------------------------------------------------------------------------
    '- Auteur      : JBES
'- Date        : 07/11/2003
'- Description : Permet d'afficher ou de cacher le div indiquant d'attendre
'-- MODIFICATION -------------------------------------------------------------------------
'- Auteur      : PBON
'- Date        : 21/03/2005
'- Description : Par defaut, si aucune action n'est en cours, le texte de la barre de
'-				 statut devient 'defaultStatus', soit 'Termine' en FR et je-ne-sais-quoi
'-				 en anglais. Bref, depend du navigateur.
'-----------------------------------------------------------------------------------------
'- ENTREE :
'-  -> bVisible : permet de rendre ou non visible le div d'attente
'-  -> bWait : Indique qu'il faut attendre 2 secondes avant d'afficher le message d'attente
'-	-> sCodeLibelleStatus : Code du libelle a afficher dans la barre de statut
'-----------------------------------------------------------------------------------------
'-- MODIFICATION -------------------------------------------------------------------------
'- Auteur      : JSOU
'- Date        : 10/03/2011
'- Description : Mise en place du style commun avec Normea 
'                et suppression de l'affichage du message Chargement en cours en parametre
'                On ne le garde que dans la barre d'etat.
'-- MODIFICATION -------------------------------------------------------------------------
'- Auteur      : MAXB
'- Date        : 23/01/2020
'- Description : Dans tous les cas si on passe le paramètre bVisible à false, il faut au moins cacher la div d'attente
'-----------------------------------------------------------------------------------------*/
export function modifWaitStatus(bVisible, bWait, sCodeLibelleStatus) {

    var oAttente = document.getElementById(DIV_ATTENTE);
    var pMsgAttente = document.getElementById("DivMsgAttente");


    if (oAttente) {
        if (window.iWaitStatusTimout) {
            clearTimeout(window.iWaitStatusTimout);
            window.iWaitStatusTimout = null;
        }

        if (bVisible === true) {

            // on affiche le curseur par wait dans tous les cas
            iws_ChangeWholeCursorStyles("wait");

            if (!window.bLoadInProgress) {

                screenCore.setWaitLabel(sCodeLibelleStatus);

                // affichage du message
                if (bWait === true) {
                    /* ARAN 16/03/2009 DYSF26841 On affiche une div transparente des que l'on clique
                    *                  pour empecher de cliquer ailleurs pendant le chargement      */
                    // JSOU 10/03/2011 DEV 41659 On applique le style commun avec Normea
                    oAttente.className = "BackGroundWait";
                    if (pMsgAttente) {
                        pMsgAttente.className = "HideDivAttente";
                    }
                    // on affiche le veuillez patienter qu'au bout de 4 secondes        
                    window.iWaitStatusTimout = window.setTimeout(function () {
                        return function () {
                            setVisibleWaitStatus(true);
                        };
                    }(), WAITTIMEOUT);

                } else {
                    // on affiche le veuillez patienter immediatement
                    setVisibleWaitStatus(true);
                    setWaitStatus(true);
                }
            }
        } else {
            // on affiche le curseur par defaut
            iws_ChangeWholeCursorStyles("");
            if (window.bLoadInProgress) {
                window.bLoadInProgress = false;
                setWaitStatus(false);
                screenCore.setWaitLabel("");
            }
            // LBRI - 2008.12.10 - [DYSF:26088] : inutile de modifier la boite d'attente
            // la fonction "SetVisibleWaitStatus" le fait tres bien.
            setVisibleWaitStatus(false);

        }
    }

    pMsgAttente = null;
    oAttente = null;

}
window.modifWaitStatus = modifWaitStatus;

// ORIC - 060505 - [EVO] : Style du pointeur de souris
// Cette fonction permet d'imposer un style a la souris sur la majeure partie des DIV de l'appli.
export function iws_ChangeWholeCursorStyles(sStyle) {
    if (screenCore.structure.divFormulaire) {
        screenCore.structure.divFormulaire.css("cursor", sStyle);
    }

    if (screenCore.structure.divDetail) {
        screenCore.structure.divDetail.css("cursor", sStyle);
    }

    if (screenCore.structure.divEntete) {
        screenCore.structure.divEntete.css("cursor", sStyle);
    }

    document.body.style.cursor = sStyle;
}
window.iws_ChangeWholeCursorStyles = iws_ChangeWholeCursorStyles;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : JBES
'- Date        : 22/02/2005
'- Description : Permet de definir si le DIV attente est affiche
'-----------------------------------------------------------------------------------------*/
export function setWaitStatus(loadInProgress) {
    screenCore.setLoadInProgress(loadInProgress);
}
window.setWaitStatus = setWaitStatus;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : JBES
'- Date        : 07/11/2003
'- Description : Permet d'afficher le div indiquant d'attendre
'-- MODIFICATION -------------------------------------------------------------------------
'- Auteur      : JBES
'- Date        : 05/11/2003
'- Description :
'-- MODIFICATION -------------------------------------------------------------------------
'- Auteur      : ARAN
'- Date        : 16/03/2009
'- Description : Dorenavant l'affichage de la Div d'attente se gere en modifiant la classe CSS
'-- MODIFICATION -------------------------------------------------------------------------
'- Auteur      : JSOU
'- Date        : 10/03/2011
'- Description : On applique le style de message d'attente commun avec normea
'-----------------------------------------------------------------------------------------*/
export function setVisibleWaitStatus(bVisible) {

    var oAttente = document.getElementById(DIV_ATTENTE);
    var pMsgAttente = document.getElementById("DivMsgAttente");
    var sLibWait = "";


    if (oAttente) {
        if (bVisible) {
            window.bLoadInProgress = true;
            setWaitStatus(true);
            // on affiche le div Attente pour bloquer tous les controles
            // LBRI - 2008.12.10 - [DYSF:26088] : la boite d'attente ne s'affichait plus
            // j'ai change le visibility=hidden en display=none et supprime toutes les
            // autres modifications qui sont devenus inutiles puisque le div n'est pas genere
            // quand display=none                

            // JSOU - 2011.03.10 Dev 41659 On applique le nouveau style commun avec Normea
            oAttente.className = "BackGroundWait";
            if (pMsgAttente) {
                pMsgAttente.className = "FrontWait FrontText";
                //TQUE 08/10/2019 Ajout de la nouvelle animation veuillez patienter
                //TQUE 23/10/2019 - DYSF88269 - On vérifie que l'animation n'a pas deja été init dans cette div (sinon elle se creer plusieurs fois)
                if (jQuery("#DivMsgAttente").find(".loading-area").length < 1) {
                    jQuery(".FrontWait.FrontText").append('<div class="loading-area"><div class="loading-circle"><div class="loading-inner-circle"></div></div></div><div id="globalWaitingMsg"></div>');
                    sLibWait = uiCore.getMessage(WAITING_FAM, WAITING).IsiLabel;
                    jQuery("#globalWaitingMsg").text(sLibWait);
                }
            }

        } else {
            window.bLoadInProgress = false;

            oAttente.className = "HideDivAttente";
            if (pMsgAttente) {
                pMsgAttente.className = "HideDivAttente";
            }

        }
    }
    oAttente = null;
    pMsgAttente = null;
}
window.setVisibleWaitStatus = setVisibleWaitStatus;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : JBES
'- Date        : 17/05/2006
'- Description : Indique si les raccourcis clavier sont actives ou non
'-----------------------------------------------------------------------------------------*/
export function getShortCutStatus() {
    return !screenCore.getShortcutDisable();
}
window.getShortCutStatus = getShortCutStatus;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : JBES
'- Date        : 17/05/2006
'- Description : Permet de definir si les raccourcis clavier sont actives ou non
'-----------------------------------------------------------------------------------------*/
export function setShortCutStatus(bShortCutActivated) {
    screenCore.setShortcutDisable(!bShortCutActivated);
}
window.setShortCutStatus = setShortCutStatus;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : MTAB
'- Date        : 03/06/2024
'- Description : Dysf 0000106024 :
'- 	   Ajoute a une url donnee l'identifiant de session unique courant, pour qu'on pert pas la session si on change le profil 
'-----------------------------------------------------------------------------------------*/
export function appendDiagSessionId(sUrl) {
    let sRetUrl = "";

    if (sUrl !== "") {
        // on verifie s'il n'est pas deja dedans
        let diagValue = getUrlVar()["diagSessionId"];
        if (diagValue) {
            diagValue = decodeURI(diagValue);
            // il n'y a pas d'identifiant de present, on va donc l'y ajouter
            // il faut s'assurer qu'il existe bien un "?"
            if (sUrl.indexOf("?") == -1) {
                // comme il n'y a pas deja de parametre sur l'url on introduit le notre
                // par le caractere "?".
                sRetUrl = sUrl + "?";

            } else {
                // comme il y a deja des parametres sur l'url, on ajoute le notre en
                // le separant des autres par le caractere "&".
                sRetUrl = sUrl + "&";
            }
            sRetUrl += diagSessionId + diagValue;
            // un identifiant est deja present, on n'en ajoute pas un suplementaire,
            // on retourne l'url telle qu'elle.
        } else {
            sRetUrl = sUrl;

        }
    }
    return sRetUrl;
}
window.appendDiagSessionId = appendDiagSessionId;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : LBRI
'- Date        : 27/12/2006
'- Description : DEV 9603
'- 	   Ajoute a une url donnee l'identifiant de session unique courant.
'-----------------------------------------------------------------------------------------*/
export function appendSessionId(sUrl) {
    let sRetUrl = "";

    if (sUrl !== "") {
        // on verifie s'il n'est pas deja dedans
        if (sUrl.indexOf(IWS_SESSION_ID_URL_PARAM) == -1) {

            let iwsSessionId = "";
            var pihdSessionId = <HTMLInputElement>document.getElementById("ihdIwsSessionId");
            if (pihdSessionId) {
                iwsSessionId = pihdSessionId.value;
                pihdSessionId = null;
            }

            // il n'y a pas d'identifiant de present, on va donc l'y ajouter
            // il faut s'assurer qu'il existe bien un "?"
            if (sUrl.indexOf("?") == -1) {
                // comme il n'y a pas deja de parametre sur l'url on introduit le notre
                // par le caractere "?".
                sRetUrl = sUrl + "?" + IWS_SESSION_ID_URL_PARAM + iwsSessionId;
            } else {
                // comme il y a deja des parametres sur l'url, on ajoute le notre en
                // le separant des autres par le caractere "&".
                sRetUrl = sUrl + "&" + IWS_SESSION_ID_URL_PARAM + iwsSessionId;
            }
        } else {
            // un identifiant est deja present, on n'en ajoute pas un suplementaire,
            // on retourne l'url telle qu'elle.
            sRetUrl = sUrl;
        }
    }

    return sRetUrl;
}
window.appendSessionId = appendSessionId;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : CLEM
'- Date        : 09/07/2018
'- Description : 
'- 	   Ajoute a une url donnee l'identifiant de session unique courant lors de l'ouverture d'un onglet
'-     DtoClient ouverture onglet
'-----------------------------------------------------------------------------------------*/
export function appendOriginSessionId(sUrl: string): string {
    let sRetUrl = "";

    if (sUrl !== "") {
        // on verifie s'il n'est pas deja dedans
        if (sUrl.indexOf(IWS_ORIGIN_SESSION_ID_URL_PARAM) == -1) {

            let iwsSessionId = "";
            var pihdSessionId = <HTMLInputElement>document.getElementById("ihdIwsSessionId");
            if (pihdSessionId) {
                iwsSessionId = pihdSessionId.value;
                pihdSessionId = null;
            }

            // il n'y a pas d'identifiant de present, on va donc l'y ajouter
            // il faut s'assurer qu'il existe bien un "?"
            if (sUrl.indexOf("?") == -1) {
                // comme il n'y a pas deja de parametre sur l'url on introduit le notre
                // par le caractere "?".
                sRetUrl = sUrl + "?" + IWS_ORIGIN_SESSION_ID_URL_PARAM + iwsSessionId;
            } else {
                // comme il y a deja des parametres sur l'url, on ajoute le notre en
                // le separant des autres par le caractere "&".
                sRetUrl = sUrl + "&" + IWS_ORIGIN_SESSION_ID_URL_PARAM + iwsSessionId;
            }
        } else {
            // un identifiant est deja present, on n'en ajoute pas un suplementaire,
            // on retourne l'url telle qu'elle.
            sRetUrl = sUrl;
        }
    }

    return sRetUrl;
}
window.appendOriginSessionId = appendOriginSessionId;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : ORIC
'- Date        : 060707
'- Description : Fonction qui ramene le nom de la vue associee actuellement affichee sur la page.
'--- CREATION -----------------------------------------------------------------------------
'- Auteur      : ARAN
'- Date        : 12/03/2010
'- Description : Deplacement de la fonction dans IsiPage.js car sinon cela generait une erreur
'-               sur la GLOB005 (et potentiellement sur d'autre ecran)
'-----------------------------------------------------------------------------------------*/
export function iws_GetDisplayedAssociatedViewName() {
    var oHiddenCtrl = <HTMLInputElement>document.getElementById('ihdNameDetail');

    if (oHiddenCtrl) {
        return oHiddenCtrl.value;
    } else {
        return null;
    }
}
window.iws_GetDisplayedAssociatedViewName = iws_GetDisplayedAssociatedViewName;

/*-- CREATION -----------------------------------------------------------------------------
'- Auteur      : JBES
'- Date        : 22/02/2005
'- Description : Indique si le DIV attente est affiche
'-----------------------------------------------------------------------------------------*/
export function GetWaitStatus() {
    if (uiCore) {
        return screenCore.getLoadInProgress();
    }
    return false;
}
window.GetWaitStatus = GetWaitStatus;



/**
 * Vérifie que l'écran courant à besoin d'être rechargé avec rafraichissement des données.
 * */
export function checkIfRefreshIsNeeded(changeState: boolean) {

    // on ne check que en consultation
    if (screenCore.getCursorState() == CURSOR_STATE_CONSULT) {

        checkIfCurrentRecordHasChanged(function (st: boolean) {
            return function (result) {
                if (result.refresh) {
                    setTimeout(function () {
                        uiCore.menuManager.openMenu(MNU_MASTER, IsiShortcut.CstMenuNavigation, FORM_REFRESH);
                    }, 300);
                } else if (st) {
                    //on passe en modif
                    iCState();
                }
            };
        }(changeState));

    }
}
window.checkIfRefreshIsNeeded = checkIfRefreshIsNeeded;
/**
 * Vérifie que l'enregistrement courant est différent en base par rapport à celui chargé dans l'écran.
 * @callback function  méthode à appeler au retour
 * */
function checkIfCurrentRecordHasChanged(callback) {

    var oAjax = new IsiSimpleAjax("../../Classes/IsiAjax/IsiAjaxRoSession.aspx", function (icallback) {
        return function (data) {
            if (data) {
                const result = JSON.parse(data);
                if (icallback) {
                    icallback(result);
                }
            }
        }
    }(callback));

    oAjax.init();
    oAjax.AsyncExecute("Traitement=IsiAsyncCheckMaj", "POST", true, "TEXT", "TEXT");

}
window.checkIfCurrentRecordHasChanged = checkIfCurrentRecordHasChanged;

/**
 * Appel le PlDesign pour ensuite renseigner les cookies d'authent'
 * */
export function manageAuthCookieUpdate(fromBandeau: string, desk: string, profil: string): Promise<IIsiUIFlowResult> {
    return new Promise<IIsiUIFlowResult>((resolve, reject) => {
        const plDesign = new IsiPlDesign;
        let deskCode;
        if (desk === "") {
            deskCode = null
        } else {
            deskCode = parseInt(desk);
        }
        plDesign.ManageAuthCookieUpdate(fromBandeau, deskCode, profil).then((result) => {
            resolve({ result: result === "", continue: true });
        });
    });
}
window.manageAuthCookieUpdate = manageAuthCookieUpdate;

/**
 * Retourne si le message des boutons de diag info/xml/sql
 * */
export async function loadDiagHeader(type: string): Promise<string> {
    const plDiagHeader = new IsiPlDiagHeader;
    return await plDiagHeader.LoadDiagHeader(type);
}
window.loadDiagHeader = loadDiagHeader

/**
 * retourne une chaine de caractère représentant le menu
 * */
export async function getRacBandeau(racName: string, racType: string, key: number, consKey: number): Promise<string> {
    const plRacBandeau = new IsiPlRacBandeau;
    return await plRacBandeau.racBandeau(racName, racType, key, consKey);
}
window.getRacBandeau = getRacBandeau;

/** 
 * retourne une chaine de caractère représentant le menu
 * */
export async function getAndBuildCsRac(requestedRacValue: string, extendedNews: boolean): Promise<IsiDtoPlRacResult> {
    const plRacBandeau = new IsiPlRac;
    return await plRacBandeau.GetAndBuildCsRac(requestedRacValue, extendedNews);
}
window.getAndBuildCsRac = getAndBuildCsRac;
